import React from 'react';
import { Link } from 'react-router-dom';
import { FiCheckCircle, FiHome, FiPhone } from 'react-icons/fi';
import { SUPPORT_PHONE_TEL } from '../constants/contact';
import './aggregator-thank-you.css';

const AggregatorThankYou = () => (
  <main className="agg-ty-page">
    <div className="agg-ty-bg" aria-hidden="true">
      <div className="agg-ty-gradient" />
      <div className="agg-ty-grid" />
      <span className="agg-ty-orb agg-ty-orb--1" />
      <span className="agg-ty-orb agg-ty-orb--2" />
    </div>

    <div className="agg-ty-shell">
      <section className="agg-ty-card" aria-labelledby="agg-ty-heading">
        <div className="agg-ty-icon-wrap" aria-hidden="true">
          <span className="agg-ty-ring" />
          <span className="agg-ty-ring agg-ty-ring--delay" />
          <div className="agg-ty-icon">
            <FiCheckCircle />
          </div>
        </div>

        <p className="agg-ty-badge">Application received</p>
        <h1 id="agg-ty-heading">Thank you</h1>
        <p className="agg-ty-lead">
          Your loan application has been submitted successfully. Our team will contact you shortly.
        </p>

        <div className="agg-ty-actions">
          <Link to="/" className="agg-ty-btn agg-ty-btn--primary">
            <FiHome /> Back to Home
          </Link>
          <a href={`tel:${SUPPORT_PHONE_TEL}`} className="agg-ty-btn agg-ty-btn--ghost">
            <FiPhone /> Call Support
          </a>
        </div>
      </section>
    </div>
  </main>
);

export default AggregatorThankYou;
